import { useLanguage } from "../../../context/LanguageProvider";
import { ROUTES } from "../../../shared/constants/routes";
import StatusMessage from "../../../shared/components/elements/StatusMessage";
import SEO from "../../../shared/components/layout/SEO";

import AccountLayout from "../components/AccountLayout";
import MyCourseCard from "../components/MyCourseCard";
import { useMyCourses } from "../hooks/useMyCourses";
import { ACCOUNT_MESSAGES } from "../messages";

const MyCoursesPage = () => {
    const { lang } = useLanguage();
    const { data: courses, loading, error } = useMyCourses();

    const breadcrumb = [
        { title: ACCOUNT_MESSAGES.account, link: "#" },
        { title: ACCOUNT_MESSAGES.myCourses, link: ROUTES.myCourses(lang) }
    ];

    const renderContent = () => {
        if (loading) return <StatusMessage>{ACCOUNT_MESSAGES.loading}</StatusMessage>;
        if (error || !courses) return <StatusMessage>{ACCOUNT_MESSAGES.failed}</StatusMessage>;
        if (courses.length === 0) return <StatusMessage>{ACCOUNT_MESSAGES.empty}</StatusMessage>;

        return (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
                {courses.map((course) => (
                    <MyCourseCard key={course.course_id} course={course} />
                ))}
            </div>
        );
    };

    return (
        <>
            {/* Private page: keep it out of search results */}
            <SEO
                title={`${ACCOUNT_MESSAGES.myCourses} | کدپرو`}
                description={ACCOUNT_MESSAGES.seoDescription}
                path="/account/course"
                noIndex
            />

            <AccountLayout breadcrumb={breadcrumb}>{renderContent()}</AccountLayout>
        </>
    );
};

export default MyCoursesPage;